import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CallPage from "../pages/call";
import NotFoundPage from "../pages/404";
import SchedulePage from "../pages/schedule";

const MainRouter: React.FC = () => (
  <Router>
    <Routes>
      <Route path="/call/:id" element={<CallPage />} />
      <Route path="/agendar/:id" element={<SchedulePage />} />
      <Route path="/404" element={<NotFoundPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </Router>
);

export default MainRouter;
